import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AddressTitleService {

  constructor(private http:HttpClient) { }


  GetRecord(Token:String):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/AddressTitle?token="+Token).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetActiveList(Token:String):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/AddressTitle/GetActiveList?token="+Token).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetSingle(Token:String,id:Number):Observable<General_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/AddressTitle/GetSingle?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as General_Interface
      })
    )
  }

  AddAddressTitle(model: General_Interface,Token:String):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      del:false,
      username:Token,
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/AddressTitle/Add",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  EditAddressTitle(model: General_Interface,Token:String):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      del:false,
      username:Token,
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/AddressTitle/Edit",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  DeleteAddressTitle(id:number,Token:String):Observable<General_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/AddressTitle/Delete?id="+id+"&token="+Token).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }


  GetAddressLetter1(id:number,Token:String):Observable<Array<string>>{
    return this.http.get(environment.BaseUrl + "Daro/AddressTitle/GetAddressLetter?token="+Token
    +"&id="+id).pipe(
      map(data=>{
        return data as Array<string>
      })
    )
  }


  SubmitAddressLetter(id:number,dsc:String,name:String,Token:String):Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/AddressTitle/SubmitAddressLetter?token="+Token
    +"&dsc="+dsc
    +"&name="+name
    +"&id="+id).pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }


  }
